export var OverlayPanelCssClass;
(function (OverlayPanelCssClass) {
    OverlayPanelCssClass["Base"] = "iress-overlay-panel";
    OverlayPanelCssClass["Wrapper"] = "iress-overlay-panel__wrapper";
    OverlayPanelCssClass["Content"] = "iress-overlay-panel__content";
    OverlayPanelCssClass["CloseButton"] = "iress-overlay-panel__close";
    OverlayPanelCssClass["Footer"] = "iress-overlay-panel__footer";
    OverlayPanelCssClass["FooterHidden"] = "iress-overlay-panel__footer--hidden";
    OverlayPanelCssClass["Backdrop"] = "iress-overlay-panel__backdrop";
})(OverlayPanelCssClass || (OverlayPanelCssClass = {}));
export var OverlayPanelSlot;
(function (OverlayPanelSlot) {
    OverlayPanelSlot["Footer"] = "footer";
})(OverlayPanelSlot || (OverlayPanelSlot = {}));
//# sourceMappingURL=overlay-panel.types.js.map